const CONFIGS_ROUTE = "/apt-pay/settlement-rule";

export const SETTLEMENT_RULE_CONFIGS_ROUTES = {
  CONFIGS_ROUTE,
};
